import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';
import { EARNINGS_URL } from 'common/api/config';

export interface EarningsEntry {
    months: number;
    value: number;
}

export const getDashboardEarningsData = () => {
    return withTokensIfNeeded<EarningsEntry[]>(`${EARNINGS_URL}?api-version=1`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });
};
